// extracted by mini-css-extract-plugin
module.exports = {"container":"progress-modal-content_container__2gTGY","spinnerWrapper":"progress-modal-content_spinnerWrapper__3k_aB","text":"progress-modal-content_text__1BQNn"};